module.exports = "<div class=\"container-fluid\">\r\n\t<div>Not implemented yet.</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/mobile/mobile.html
// module id = 109
// module chunks = 0